import { pbrExt } from './fragments/emissive-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setPbrEmissive(mat, color) {
  mat._emissiveColor = color;
  _registerPbrExt(pbrExt);
}

export { setPbrEmissive };
//# sourceMappingURL=set-emissive.js.map
